export default {
  // Hero
  eventHeroTag: "Événements & Réseautage",
  eventHeroTitle1: "Connectez, Apprenez",
  eventHeroTitle2: "& Progressez Ensemble",
  eventHeroDesc: "AIP organise et sélectionne des conférences, ateliers et webinaires qui réunissent des investisseurs, entrepreneurs et parties prenantes gouvernementales en Afrique de l'Est.",
  eventTypeConference: "Conférences",
  eventTypeWorkshop: "Ateliers",
  eventTypeWebinar: "Webinaires",
  eventTypeNetworking: "Réseautage",
  eventCtaUpcoming: "Voir les Événements à Venir",
  eventCtaPast: "Événements Passés",
  eventStat1: "Événements Organisés",
  eventStat2: "Participants Totaux",
  eventStat3: "Conférenciers",
  eventStat4: "Pays Représentés",
  eventFeatured: "Événement en Vedette",
  eventTagUpcoming: "À venir · En vedette",
  eventSpeakers: "Conférenciers",
  eventExpected: "Attendus",
  eventSpotsLeft: "Places Restantes",
  eventRegistered: "inscrits",
  eventFull: "plein",

  // Upcoming
  upcomingTag: "À venir",
  upcomingTitle1: "Événements",
  upcomingTitle2: "à Venir",
  upcomingDesc: "Inscrivez-vous maintenant et réservez votre place à nos événements à venir.",
  upcomingCount: "événements prévus",
  upcomingOnline: "En Ligne",
  upcomingInPerson: "En Personne",
  upcomingSpotsLeft: "places restantes",
  upcomingViewDetails: "Voir les Détails",
  upcomingRegister: "S'inscrire",

  // Past
  pastTag: "Archives",
  pastTitle1: "Événements",
  pastTitle2: "Passés",
  pastDesc: "Un regard rétrospectif sur nos événements qui ont façonné les connexions en Afrique de l'Est.",
  pastAttendees: "participants",

  // Detail
  detailBack: "Retour aux Événements",
  detailAbout: "À Propos de cet Événement",
  detailDate: "Date",
  detailLocation: "Lieu",
  detailSector: "Secteur",
  detailAgenda: "Programme de l'Événement",
  detailSpeakers: "Conférenciers",
  detailAttendance: "Participation à l'Événement",
  detailParticipants: "participants ont assisté à cet événement",
  detailPastMessage: "Événement Terminé",
  detailPastDesc: "Cet événement n'accepte plus d'inscriptions.",
  detailPastCta: "Voir les Événements à Venir",
  detailRegisterTitle: "S'inscrire à cet Événement",
  detailRegisterDesc: "Réservez votre place — les places sont limitées.",
  detailRegistered: "inscrits",
  detailSpotsLeft: "places restantes",
  detailFormName: "Nom complet",
  detailFormEmail: "Email",
  detailFormCompany: "Entreprise",
  detailFormPhone: "Téléphone",
  detailFormSubmit: "S'inscrire",
  detailFormSubmitting: "Inscription en cours...",
  detailFormSuccessTitle: "Inscription Confirmée!",
  detailFormSuccessBody: "Vérifiez votre email pour les détails de confirmation.",
};